import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { mobilePlatforms } from "@/mocks/installData";

export default function MobileInstall() {
  const [activeId, setActiveId] = useState(mobilePlatforms[0].id);
  const active = mobilePlatforms.find((p) => p.id === activeId) ?? mobilePlatforms[0];

  return (
    <section id="mobile" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Mobile Install"
          title="手机版客户端安装步骤"
          desc="安卓与 iPhone 的安装方式略有不同，切换下方标签查看对应流程。安装包体积小巧，全程一般不超过三分钟。"
        />

        <div className="max-w-6xl mx-auto mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="relative rounded-xl overflow-hidden bg-background-200 h-[320px] md:h-[560px]">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20smartphone%20held%20in%20hand%20displaying%20a%20dark%20themed%20video%20streaming%20app%20interface%20with%20warm%20amber%20accents%2C%20clean%20minimal%20studio%20background%2C%20soft%20natural%20lighting%2C%20premium%20product%20photography%20style%2C%20high%20detail&width=800&height=1000&seq=starfilm-phone-2026&orientation=portrait"
              alt="星辰影视手机版客户端运行界面示意"
              className="absolute inset-0 w-full h-full object-top"
            />
          </div>

          <div>
            <div className="inline-flex bg-background-200 p-1 rounded-full">
              {mobilePlatforms.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => setActiveId(p.id)}
                  className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors flex items-center gap-2 ${
                    activeId === p.id
                      ? "bg-background-50 text-foreground-950"
                      : "text-foreground-600 hover:text-foreground-900"
                  }`}
                >
                  <i className={p.icon}></i>
                  {p.tab}
                </button>
              ))}
            </div>

            <div className="mt-6 bg-background-50 border border-background-200 rounded-lg p-5">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <span className="inline-flex items-center gap-2 text-xs text-accent-700 bg-accent-100 px-3 py-1 rounded-full font-label">
                  <i className="ri-checkbox-circle-line"></i>
                  {active.badge}
                </span>
                <span className="text-xs text-foreground-500 font-label">{active.systemReq}</span>
              </div>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{active.summary}</p>
              <div className="mt-3 flex flex-col sm:flex-row sm:items-center gap-2 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-file-line"></i>
                  {active.packageName}
                </span>
                <span className="hidden sm:inline text-background-400">·</span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-scales-3-line"></i>
                  {active.packageSize}
                </span>
              </div>
            </div>

            <ol className="mt-6 flex flex-col gap-4">
              {active.steps.map((step, index) => (
                <li key={step.id} className="flex gap-4">
                  <div className="shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-label">
                    {index + 1}
                  </div>
                  <div className="pt-0.5">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                      {step.title}
                    </h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <a
              href="#versions"
              className="mt-6 inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm px-5 py-2.5 rounded-md cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-download-2-line"></i>
              下载 {active.tab}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}